import { StyleSheet, View } from 'react-native';

import { ActionButton } from 'components/ui/action-button';
import { useIsLargeFontScale } from 'hooks/use-is-large-font-scale';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { classifyPaymentMethods } from '../../utils';
import { PaymentMethodDetails } from '../payment-method-details';
import { PaymentMethodIcon } from '../payment-method-icon';

import { SelectorSelectionProps } from './types';

export function SelectorSelection({
  methods,
  selectedMethodId = '',
  onChange,
  isDisabled,
  changeButtonEventAttributes,
}: SelectorSelectionProps) {
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId);
  const isLargeFontScale = useIsLargeFontScale();

  return (
    <View
      testID="selector-selection"
      style={[styles.container, isLargeFontScale && styles.stackedContainer]}
    >
      <View style={[styles.content, isLargeFontScale && styles.stackedContent]}>
        <PaymentMethodIcon paymentMethod={selectedMethod} size="lg" bordered />
        <View style={styles.details}>
          <PaymentMethodDetails paymentMethod={selectedMethod} />
        </View>
      </View>
      <ActionButton
        testID="change-btn"
        width="auto"
        fullWidth={isLargeFontScale}
        customStyles={isLargeFontScale ? styles.stackedChangeButton : styles.changeButton}
        onPress={onChange}
        disabled={isDisabled}
        eventAttributes={changeButtonEventAttributes}
      >
        {t('change')}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  stackedContainer: {
    flexDirection: 'column',
    alignItems: 'stretch',
    flexGrow: 0,
    gap: spacing.$2,
  },
  content: {
    flex: 1,
    flexShrink: 1,
    flexDirection: 'row',
    gap: spacing.$4,
    minWidth: 0,
    paddingRight: spacing.$2,
    justifyContent: 'center',
  },
  stackedContent: {
    flexGrow: 0,
    width: '100%',
    paddingRight: 0,
  },
  details: {
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
    justifyContent: 'center',
  },
  changeButton: {
    flexShrink: 0,
  },
  stackedChangeButton: {
    flexShrink: 0,
    alignSelf: 'stretch',
    width: '100%',
  },
});
